/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Theft_Of_Tournament_MaterialInputs */



/**
* | output |
* | --- |
* | "Theft of Tournament Material" |
*
* @param {Sanction_Sub_Theft_Of_Tournament_MaterialInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_theft_of_tournament_material = /** @type {((inputs?: Sanction_Sub_Theft_Of_Tournament_MaterialInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Theft_Of_Tournament_MaterialInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vol de Matériel de Tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Robo de Material de Torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Roubo de Material de Torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Furto di Materiale di Torneo")
	return /** @type {LocalizedString} */ ("Theft of Tournament Material")
});